import request from '@/utils/request'

export const test = (data: any) => request({
    url: '/manage/jump-checkout-counter',
    method: 'post',
    data
})